import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";

function ScrollToTop() {
    const { pathname } = useLocation();
    const navigationType = useNavigationType(); // "PUSH", "POP", or "REPLACE"

    useEffect(() => {
        if (navigationType !== "POP") {
            scroll.scrollToTop({
                duration: 500,
                smooth: "ease"
            });
        }
    }, [pathname, navigationType]);

    return null;
}

export default ScrollToTop;
